import { Component, OnInit, Input, Inject, Output, EventEmitter } from 'ng-metadata/core';
import { GetItRequestService } from './getItRequest.service';
import { FormBuilderEnums } from '../../../../infra/formBuilder/formBuilder.service';
import { NgrsService } from '../ngrs.service';
import { PhysicalBestOfferService } from '../physicalBestOffer/physicalBestOffer.service';
import { UserSessionManagerService } from '../../../../security/userSessionManager.service';
import {
    getVid,
    isShowPhysicalJournalOffer,
    isRapidoOfferByResourceTypeEnabled
} from '../../../..//appConfig/appConfigForward';
import { forEach } from 'angular';
import { getResourceType, getGenreType, getPublicationDate } from '../../../../infra/ngrsUtil';
import {SmoothScrollUtil} from '../../../../nddUtils/smoothScrollUtil.service';
import { PickupAnywhereService } from '../pickup-anywhere-form/pickupAnywhereForm.service';
import {getInstitutionCode} from '../../../../appConfig/appConfigForward';
import {mmsIdOfferOutputMap} from '../BestOffer.interface';
import {JwtUtilService} from '../../../../security/jwtUtil.service';
import {ConfigurationUtil} from '../../../../nddUtils/configurationUtil.service';
import {PermalinkService} from "../../../actions/permalinkAction/permalink.service";
import {MappingTablesCache} from '../../../../mappingTablesCache/mappingTablesCache.service';

const get = require('lodash/get');
const lastResortHtml =  'lastResortGetItRequest.html';
const largeHtml =  'bookGetItRequest.html';
const smallHtml =  'otherGetItRequest.html';


@Component({
    "inputs": ['opendigitalform', 'openphysicalform', 'openblankform', 'showmessagebar', 'display', 'offerfound'],
    selector: 'prm-get-it-request',
    templateUrl: 'components/search/fullView/ngrs/getItRequest/getItRequest.html',
})

export class PrmGetItRequest implements OnInit {

    @Input() item: Object;
    @Input() bestoffer: Object;
    @Input() bestebookoffer: Object;
    @Input() digitalbestoffer: Object;
    @Input() private isdigitaloffer: boolean;
    @Input() private isblankform: boolean;
    @Input() formscustomization: any;
    @Input() rapidoservices: Array<any>;

    private vid: string = getVid();
    private _alternativeEmailCode: string;
    private _formData: Object = {};
    private _isDigitalFormValid: boolean;
    private _isEBookFormValid: boolean;
    private _isPhysicalJournalFormValid: boolean;
    private _isLargeForm: boolean;
    private _borrowingRequestMessage: string;
    private _borrowingRequestOK: boolean;
    private _showCopyRightsStatement = false;
    private _requestSubmitted = false;
    private _showRequestFormMessage = false;
    private _showArticleFromJournalRequestFormMessage = false;
    private focusedAlternativeEmail:boolean = false;
    private _pickupAnywhereEnabled: boolean = false;
    private _refineOfferDisabled: boolean = true;
    private _refineOfferInProgress: boolean = false;
    private refineFieldsSnapshot = {
        myPublicationDate: undefined,
        myVolume: undefined,
        mySpecificEditionOnly: false,
        mySpecificEditionPublicationDate: undefined,
        myEdition: undefined,
        puaPickupMember: -1,
        myResourceType: ''
    };
    private _refined : boolean = false;
    private _canRestore: boolean = false;
    private _bestOffer: Object = {};
    private _mmsId: string;
    private _requestFormMessage;
    private _articleFromJournalRequestFormMessage;
    private isChapterFormValid: boolean = true;
    private _pickupInstitutionAndLocationMap: Object = {};
    private _pickupInstitutionDefault: string;
    private _pickupLibraryDefault: string;
    private _pickupLocationLocal: Object = {};
    private _isPuaOffer: boolean = false;
    private _showSubMenuForPua: boolean = true;
    private _showSpecificEditionRefineWarning: boolean = false;
    private _showVolumeRefineWarning: boolean = false;
    private _showPublicationDateRefineWarning: boolean = false;
    private _showPickupMemberRefineWarning: boolean = false;
    private _showResourceTypeRefineWarning: boolean = false;
    private _availableResourceTypes: string[] = [];
    private _selectedResourceType: string = '';


    private _dateField = {
        name: 'myDate', label: '', uiType: FormBuilderEnums.UI_TYPE.DATE, placeHolder: 'nui.ngrs.request.physical.date_needed_by', populator: {
            params: {
                allow: FormBuilderEnums.FUTURE_DATES
            }
        },  mandatory:false, mandatoryIndicator:false
    };
    private _volumeField = { name: 'myVolume', label: 'nui.ngrs.request.volume', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator: false };
    private _noteField = { name: 'myNote', label: 'nui.ngrs.request.note', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator: false };
    private _locationField = {
        key: 'pickupLocation',
        name: 'myLocation',
        mandatory: true,
        mandatoryIndicator: true,
        path: 'groups-list-map/pickupLocation',
        label: 'nui.ngrs.pickup.information.pickupLibrary',
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH,
        populator: {
            params: {
                byCategory: true
            }
        }
    };
    private _pickupMembersField = {
        key: 'pickupMembers',
        name: 'myPickupMember',
        mandatory: true,
        mandatoryIndicator: true,
        path: 'groups-list-map/pickupMembers',
        label: 'nui.ngrs.pickup.information.pickupLibrary',
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH,
        events: {
            onChange: this.setPickupMember.bind(this)
        }
    };
    private _pickupInstitutionFNField = {
        key: 'pickupInstitution',
        name: 'myPickupInstitution',
        mandatory: true,
        value: '',
        mandatoryIndicator: true,
        path: 'ful-net-rs-groups-list-map/preferredPickupInstitution',
        label: 'almaResourceSharing.pickupInstitution',
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH,
        events: {
            onChange: this.setPickupLibrariesLocation.bind(this)
        }
    };
    private _pickupLibraryFNField = {
        key: 'pickupLibrary',
        name: 'myPickupLibrary',
        mandatory: true,
        value: '',
        mandatoryIndicator: true,
        path: 'ful-net-rs-groups-list-map/preferredPickupLocation',
        label: 'nui.ngrs.pickup.information.pickupLibrary',
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH
    };
    private _locationFieldForEBookRequest = {
        key: 'pickupLocationForEBook',
        name: 'myLocationForEBook',
        mandatory: false,
        mandatoryIndicator: false,
        path: 'groups-list-map/pickupLocation',
        label: 'nui.ngrs.pickup.information.pickupLibraryForEBook',
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH,
        populator: {
            params: {
                byCategory: true
            }
        }
    };
    private _emailField = {
        name: 'myEmail',
        label: 'nui.ngrs.request.digital.email',
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
        mandatory: true,
        mandatoryIndicator : true
    };
    private _alternativeEmailField = {
        name: 'myAlternativeEmail',
        label: 'nui.ngrs.request.digital.alternative_email',
        uiType: FormBuilderEnums.UI_TYPE.TEXT,
        mandatory: true,
        mandatoryIndicator : true
    };
    private _articleTitleField = { name: 'myArticleTitle', label: 'nui.ngrs.request.journal.article.title', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator:true};
    private _articleAuthorField = { name: 'myArticleAuthor', label: 'nui.ngrs.request.journal.article.author', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _issueField = { name: 'myIssue', label: 'nui.ngrs.request.journal.issue', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _publicationDateField = { name: 'myPublicationDate', label: 'nui.ngrs.request.journal.publication.date', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _chapterTitleField = { name: 'myChapterTitle', label: 'nui.ngrs.request.digital.chapter_title', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _chapterAuthorField = { name: 'myChapterAuthor', label: 'nui.ngrs.request.digital.chapter_author', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _chapterNumberField = { name: 'myChapterNumber', label: 'nui.ngrs.request.digital.chapter_number', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _fromPageField = { name: 'myFromPage', label: 'nui.ngrs.request.digital.from_page', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _toPageField = { name: 'myToPage', label: 'nui.ngrs.request.digital.to_page', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _composerField = { name: 'myComposer', label: 'nui.ngrs.request.digital.composer', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _opusField = { name: 'myOpus', label: 'nui.ngrs.request.digital.opus', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _songMovementField = { name: 'mySongMovement', label: 'nui.ngrs.request.digital.song_movement', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _partField = { name: 'myPart', label: 'nui.ngrs.request.digital.part', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _allowOtherFormats = { label: "nui.ngrs.request.no_offer.allow_digital", checked: false };
    private _copyRightsCheckBoxField = {
        name: 'copyRightsRapido',
        uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
        mandatory: true,
        mandatoryIndicator: true,
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        value: '',
        options: [
            {
                name: 'copyRights',
                label: 'nui.ngrs.request.no_offer.book',
                value: false,
            }
        ]
    }
    private _specificEditionCheckBoxField = {
        name: 'mySpecificEditionOnly',
        uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        value: '',
        options: [
            {
                name: 'specificEditionOnlyValue',
                label: this.$translate.instant('nui.ngrs.request.specificEditionOnly'),
                value: false,
            }
        ]
    }
    private _specificEditionPublicationDateField = { name: 'mySpecificEditionPublicationDate', label: 'nui.ngrs.request.journal.publication.date', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator:true};
    private _editionField = { name: 'myEdition', label: 'nui.ngrs.request.edition', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _levelOfServiceField = {
        name: 'myLevelOfService',
        label: 'nui.ngrs.request.digital.level_of_service',
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
        mandatory: false,
        mandatoryIndicator: false
    };
    private _additionalInformationField = {
        name: 'myAdditionalInformation',
        label: 'nui.ngrs.request.additional.information',
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
        mandatory: false,
        mandatoryIndicator: false
    };
    private _resourceTypeField = {
        name: 'myResourceType',
        label: 'nui.ngrs.resourceType.label',
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
        mandatory: false,
        mandatoryIndicator: false
    };
    private _showAdditionalInformationField: boolean = false;
    private offerInitiallyExists: boolean = false;
    private offerInitiallyeBook: boolean = false;


    constructor(private getItRequestService: GetItRequestService,
        private ngrsService: NgrsService,
        private jwtUtilService: JwtUtilService,
        private userSessionManagerService: UserSessionManagerService,
        private physicalBestOfferService: PhysicalBestOfferService,
        private permalinkService: PermalinkService,
        private smoothScrollUtil : SmoothScrollUtil,
        private pickupAnywhereService: PickupAnywhereService,
        private configurationUtil: ConfigurationUtil,
        private mappingTablesCache: MappingTablesCache,
        @Inject('$sce') private $sce,
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('actionIcons') private  actionIcons: Object,
        @Inject('$translate') private $translate,
        @Inject('$scope') private $scope: ng.IScope) {
        this._pickupAnywhereEnabled = window.appConfig['system-configuration'].ngrs_pickup_anywhere;
        if (this.openphysicalform && this.openphysicalform.isEbook) {
            this._bestOffer = this.bestebookoffer;
            this.offerInitiallyeBook = true;
        } else {
            this._bestOffer = this.bestoffer;
        }

        const currentOfferDetails = this.isdigitaloffer ? this.digitalbestoffer : this._bestOffer;
        this.offerInitiallyExists = !this.noOfferFound(currentOfferDetails);

        let reqParams = { 'vid': this.vid };
        this.itemDetailsRequest = {
            'AlmaResourceSharing': {
                'allowed': "Y",
                'link-to-service': "/primaws/rest/priv/ILSServices/titleServices/-1/-1/AlmaResourceSharing?institution=",
                'service-type': "OvP",
                'type': "AlmaResourceSharing"
            }
        };
        this._showRequestFormMessage = false;
        this._showArticleFromJournalRequestFormMessage = this.isDigitalServiceWithNoKnownTerms();
        this.setMandatoryFields();
        if (this.isblankform) {
            this.physicalBestOfferService.getEmailList().then((response) => this.setEmail(response));
            this.physicalBestOfferService.getPickupLocation(false).then((response) => this.setPickupLocation(response));
            this.physicalBestOfferService.getCopyRightsStatement().then((response) => this.setCopyRightsStatement(response));
        }
        else if (this.isDigitalOffer()) {
            this.physicalBestOfferService.getEmailList().then((response) => this.setEmail(response));
            this.physicalBestOfferService.getCopyRightsStatement().then((response) => this.setCopyRightsStatement(response));
        } else {
            if(this.isEbookOffer()){
                this.physicalBestOfferService.getEmailList().then((response) => this.setEmail(response));
            }
            if(!this._pickupAnywhereEnabled){
                this.physicalBestOfferService.getPickupLocation(this.isFNRotaOfferDropDowns()).then((response) => this.setPickupLocation(response));
            }
            this._isPuaOffer = this.isPuaOffer();
            if (this._isPuaOffer) {
                this.setupPua();
            }
        }
        let formType = this.isdigitaloffer ? "digital" : this.isEbookOffer() ? "electronic" : "physical";
        const resourceType = getResourceType(this.item);
        this.getItRequestService.getRequestFormMessage(formType).then((response)=> this.setRequestFormMessage(response));
        if (this.isArticleFromJournal()) {
            this.getItRequestService.getRequestFormMessage(formType, resourceType).then((response)=> this.setRequestFormMessage(response, true));
        }

        this.$scope.$watch('$ctrl.formData.myPublicationDate', (newPublicationDate, oldPublicationDate) => {
            this.onPhysicalJournalFieldChange('myPublicationDate', newPublicationDate);
            this.onArticleFromJournalFieldChange('myPublicationDate', newPublicationDate);
            this.onRefineFieldChange(newPublicationDate, oldPublicationDate, 'myPublicationDate');
        }, true);
        this.$scope.$watch('$ctrl.formData.myVolume', (newVolume, oldVolume) => {
            this.onPhysicalJournalFieldChange('myVolume', newVolume);
            this.onArticleFromJournalFieldChange('myVolume', newVolume);
            this.onRefineFieldChange(newVolume, oldVolume, 'myVolume');
        }, true);

        this.$scope.$watch('$ctrl.formData.mySpecificEditionOnly', (newVolume, oldVolume) => {
            this.onRefineFieldChange(newVolume, oldVolume, 'mySpecificEditionOnly');
        }, true);
        this.$scope.$watch('$ctrl.formData.mySpecificEditionPublicationDate', (newVolume, oldVolume) => {
            this.onRefineFieldChange(newVolume, oldVolume, 'mySpecificEditionPublicationDate');
        }, true);
        this.$scope.$watch('$ctrl.formData.myEdition', (newVolume, oldVolume) => {
            this.onRefineFieldChange(newVolume, oldVolume, 'myEdition');
        }, true);
        this.$scope.$watch('$ctrl.formData.myPickupMember', (newPickup, oldPickup) => {
            this.onRefineFieldChange(newPickup, oldPickup, 'myPickupMember');
        }, true);
        this.$scope.$watch('$ctrl.formData.myResourceType', (newResourceType, oldResourceType) => {
            this.onRefineFieldChange(newResourceType, oldResourceType, 'myResourceType');
        }, true);


        this.setLevelOfServiceOptions(this.formscustomization);
        this.setAdditionalInformationOptions();
    }

    ngOnInit() {
        // Initialize multi-type resource handling (moved here so inputs are available)
        this.initializeResourceTypeFromOffer(this._bestOffer);

        //this.physicalBestOfferService.getPickupLocation().then((response) => this.setpickupInstitutionAndLocationMap(response));
        this.$timeout(() => {
            let element = document.querySelector('#offer_request_main_tile') as HTMLElement;
            if (element) {
                element.setAttribute('tabindex', '-1');
                element.focus();
                element.setAttribute('tabindex', '0');
            } else {
                element = document.querySelector('#no_offer_request_main_tile') as HTMLElement;
                if (element) {
                    element.setAttribute('tabindex', '-1');
                    element.focus();
                    element.setAttribute('tabindex', '0');
                }
            }
        }, 100);
        this._isDigitalFormValid = true;
        this._isPhysicalJournalFormValid = true;
        this._isEBookFormValid = true;
    }

    private setupPua(){
        this._locationField.label = this.$translate.instant("nui.ngrs.pickup.information.localPickupLibrary");
        this._pickupMembersField.options = this.parsePickupMemberOptions(this._bestOffer.puaCentralMembers);
        this._pickupMembersField.mandatory = this.isPickupLocationFieldMandatory();
        this._pickupMembersField.mandatoryIndicator = this._pickupMembersField.mandatory;
        this._formData.myPickupMember = -1;
    }

    private parsePickupMemberOptions(options: Record<number, string>) {
        let comboOptions = [];
        if (options != undefined) {
            forEach(options, (option, key) => comboOptions.push({ "label": option, "value": key }));
            comboOptions.sort((a, b) => this.sortMembers(a, b));
        }
        return comboOptions;
    }

    private sortMembers(m1: {value: long, label: string}, m2 : {value: long, label: string}) {
        if (this.isMyInstitutionPickupMember(m1)) {
            return -1;
        } else if (this.isMyInstitutionPickupMember(m2)) {
            return 1;
        }
        return m1.label.localeCompare(m2.label);
    }

    private isMyInstitutionPickupMember(member: {value: long, key: string}) : boolean {
        return  member.value == -1;
    }

    private isPickupLocationFieldMandatory() : boolean{
        return this.isCodeMandatoryForForm('PICKUP_LOCATION')
    }

    private setMandatoryFields(){
        this._articleAuthorField.mandatory = this.isCodeMandatoryForForm('ARTICLE_AUTHOR');
        this._articleAuthorField.mandatoryIndicator = this._articleAuthorField.mandatory;

        this._articleTitleField.mandatory = this.isCodeMandatoryForForm('ARTICLE_TITLE');
        this._articleTitleField.mandatoryIndicator =   this._articleTitleField.mandatory;

        this._issueField.mandatory = this.isCodeMandatoryForForm('ISSUE');
        this._issueField.mandatoryIndicator = this._issueField.mandatory;

        this._publicationDateField.mandatory = this.isCodeMandatoryForForm('PUBLICATION_DATE');
        this._publicationDateField.mandatoryIndicator = this._publicationDateField.mandatory;

        this._chapterTitleField.mandatory = this.isCodeMandatoryForForm('CHAPTER_TITLE');
        this._chapterTitleField.mandatoryIndicator = this._chapterTitleField.mandatory;

        this._chapterAuthorField.mandatory = this.isCodeMandatoryForForm('CHAPTER_AUTHOR');
        this._chapterTitleField.mandatoryIndicator = this._chapterAuthorField.mandatory;

        this._chapterNumberField.mandatory = this.isCodeMandatoryForForm('CHAPTER_NUMBER');
        this._chapterNumberField.mandatoryIndicator = this._chapterNumberField.mandatory;

        this._fromPageField.mandatory = this.isCodeMandatoryForForm('FROM_PAGE_TO_PAGE');
        this._fromPageField.mandatoryIndicator = this._fromPageField.mandatory;

        this._toPageField.mandatory = this.isCodeMandatoryForForm('FROM_PAGE_TO_PAGE');
        this._toPageField.mandatoryIndicator = this._toPageField.mandatory;

        this._composerField.mandatory = this.isCodeMandatoryForForm('COMPOSER');
        this._composerField.mandatoryIndicator = this._composerField.mandatory;

        this._opusField.mandatory = this.isCodeMandatoryForForm('OPUS');
        this._opusField.mandatoryIndicator = this._opusField.mandatory;

        this._songMovementField.mandatory = this.isCodeMandatoryForForm('SONG_MOVEMENT');
        this._songMovementField.mandatoryIndicator = this._songMovementField.mandatory;

        this._partField.mandatory = this.isCodeMandatoryForForm('PART');
        this._partField.mandatoryIndicator = this._partField.mandatory;

        if(this.isDigitalOffer()) {
            this._levelOfServiceField.mandatory = this.isCodeMandatoryForForm('LEVEL_OF_SERVICE_DIGITAL');
        }
        else {
            this._levelOfServiceField.mandatory = this.isCodeMandatoryForForm('LEVEL_OF_SERVICE_PHYSICAL');
        }
        this._levelOfServiceField.mandatoryIndicator = this._levelOfServiceField.mandatory;

        this._emailField.mandatory = this.isCodeMandatoryForForm('EMAIL');
        this._emailField.mandatoryIndicator = this._emailField.mandatory;

        this._alternativeEmailField.mandatory = this.isCodeMandatoryForForm('EMAIL');
        this.alternativeEmailField.mandatoryIndicator = this._alternativeEmailField.mandatory;

        this._dateField.mandatory = this.isCodeMandatoryForForm('NOT_NEEDED_AFTER');
        this._dateField.mandatoryIndicator = this._dateField.mandatory;

        this._noteField.mandatory = this.isCodeMandatoryForForm('NOTE');
        this._noteField.mandatoryIndicator = this._noteField.mandatory;

        this._pickupInstitutionFNField.mandatory = this.isCodeMandatoryForForm('PICKUP_INSTITUTION');
        this._pickupInstitutionFNField.mandatoryIndicator = this._pickupInstitutionFNField.mandatory;

        this._locationField.mandatory = this.isCodeMandatoryForForm('PICKUP_LOCATION');
        this._locationField.mandatoryIndicator = this._locationField.mandatory;

        this._volumeField.mandatory = this.isCodeMandatoryForForm('VOLUME');
        this._volumeField.mandatoryIndicator = this._volumeField.mandatory;

        this._locationFieldForEBookRequest.mandatory = this.isCodeMandatoryForForm('PICKUP_LOCATION_FOR_EBOOK');
        this._locationFieldForEBookRequest.mandatoryIndicator = this._locationFieldForEBookRequest.mandatory;

        this._editionField.mandatory = this.isCodeMandatoryForForm('EDITION');
        this._editionField.mandatoryIndicator = this._editionField.mandatory;

        this._additionalInformationField.mandatory = this.isCodeMandatoryForForm('ADDITIONAL_INFORMATION');
        this._additionalInformationField.mandatoryIndicator = this._additionalInformationField.mandatory;

        this._resourceTypeField.mandatory = this.isCodeMandatoryForForm('RESOURCE_TYPE');
        this._resourceTypeField.mandatoryIndicator = this._resourceTypeField.mandatory;
    }

    public get volumeField() {
        return this._volumeField;
    }

    public get noteField() {
        return this._noteField;
    }

    private setPickupLocation(response) {
        let comboOptions = [];
        let optionsMap = new Map();
        forEach(response, (element, value) => {
            if ((value === 'groups-list-map')) {
                forEach(element, (owner) => {
                    comboOptions = this.parseOptions(owner.pickupLocation, comboOptions, optionsMap);
                    comboOptions = this.parseOptions(owner.preferredLocalPickupLocation, comboOptions, optionsMap);
                });
                this._pickupLocationLocal = element;
            }
            if ((value === 'ful-net-rs-groups-list-map')) {
                this._pickupInstitutionAndLocationMap = element;
            }
            if ((value === 'preferredPickupInstitutionDefault')) {
                this._pickupInstitutionDefault = element;
            }
            if ((value === 'preferredLocalPickupLocationDefault')) {
                this._pickupLibraryDefault = element;
            }
        });
        let defaultValue = this.getDefaultValue(response, comboOptions);
        if (defaultValue) {
            this._locationField.mandatory = false;
            this._formData.myLocation = defaultValue;
            this._locationFieldForEBookRequest.mandatory = false;
            this._formData.myLocationForEBook = defaultValue;
        }
        if (!this.isCodeEnabledforForm('PICKUP_LOCATION') && comboOptions.length) {
            this._formData.myLocation = comboOptions[0].value;
        } else {
            this._locationField.options = comboOptions;
        }
        if (!this.isCodeEnabledforForm('PICKUP_LOCATION_FOR_EBOOK') && comboOptions.length) {
            this._formData.myLocationForEBook = comboOptions[0].value;
        } else {
            this._locationFieldForEBookRequest.options = comboOptions;
        }
       if (this.isFNRotaOfferDropDowns()){           
            this.setPickupInstitutionsLocation();       
       }     
    }


    private getDefaultValue(response: any, comboOptions: any[]) {
        if (comboOptions.length == 1) {
            return comboOptions[0].value
        }
        let defaultValueIndexFilter;
        if (this.isFNRotaOfferDropDowns()){
            defaultValueIndexFilter = (element) => element.value == response.pickupLocationDefault;
        } else {
            defaultValueIndexFilter = (element) => element.value == response.preferredLocalPickupLocationDefault;
        }
        let defaultValueIndex = comboOptions.findIndex(defaultValueIndexFilter);
        if (defaultValueIndex > -1) {
            return comboOptions[defaultValueIndex].value;
        }
    }

    private setEmail(response) {
        let emailComboOptions = [];
        forEach(response, (option) => emailComboOptions.push({ "label": option, "value": option }));
        this._emailField.options = emailComboOptions;
        if (emailComboOptions[0]) {
            this._formData.myEmail = emailComboOptions[0].value;
            if (this._emailField.mandatory) {
                this._emailField.mandatoryIndicator = true;
            }
            else {
                this._emailField.mandatory = false;
            }
        }
        this._alternativeEmailCode = emailComboOptions[emailComboOptions.length - 1].value;
    }

    private setLevelOfServiceOptions(formsCustomization) {
        if(((!this.isDigitalOffer() && this.isCodeEnabledforForm('LEVEL_OF_SERVICE_PHYSICAL')) || 
            (this.isDigitalOffer() && this.isCodeEnabledforForm('LEVEL_OF_SERVICE_DIGITAL')))
            && formsCustomization){
            let levelOfServiceOptions = [];
            let responseOptions = formsCustomization.levelOfServiceOptions;
            forEach(Object.keys(responseOptions), (optionKey) => levelOfServiceOptions.push({ "label": responseOptions[optionKey], "value": optionKey }));
            this._levelOfServiceField.options = levelOfServiceOptions;
            if(formsCustomization.defaultLevelOfService){
                this._formData.myLevelOfService = formsCustomization.defaultLevelOfService;
            }
        }
    }

    private setAdditionalInformationOptions() {
        const additionalInfoTable = this.mappingTablesCache.getTable(this.mappingTablesCache.tables.RESOURCE_SHARING_ADDITIONAL_INFORMATION) || [];
        if (additionalInfoTable.length > 0 && this.isCodeEnabledforForm('ADDITIONAL_INFORMATION')) {
            let additionalInfoOptions = [];
            additionalInfoOptions.push({ "label": " ", "value": "" });
            forEach(additionalInfoTable, (row) => additionalInfoOptions.push({ "label": row.source1, "value": row.source2 }));
            this._additionalInformationField.options = additionalInfoOptions;
            this._showAdditionalInformationField = true;
        }
    }

    private setCopyRightsStatement(response) {
        if (response && !this.isEmpty(response)) {
            this._showCopyRightsStatement = true;
            this._copyRightsCheckBoxField.options[0].label = this.$sce.trustAsHtml(response);
        }
    }

    private setRequestFormMessage(response, articleFromJournal?: boolean) {
        if (articleFromJournal && response && !this.isEmpty(response)) {
            this._articleFromJournalRequestFormMessage = this.$sce.trustAsHtml(response);
            this._showArticleFromJournalRequestFormMessage = this.isDigitalServiceWithNoKnownTerms();
        } else if (response && !this.isEmpty(response)) {
            this._requestFormMessage = this.$sce.trustAsHtml(response);
            this._showRequestFormMessage = true;
        }
    }

    private isEmpty(response: string): boolean {
        return (response.length === 0 || !response.trim());
    }

    private parseOptions(options, comboOptions, optionsMap) {
        if (options != undefined) {
            options.sort(this.compare);
            options.forEach((option) => comboOptions.push({ "label": option.value, "value": option.key, "category": option.category ? option.category : this.$translate.instant("nui.ngrs.request.no.campus") }));
            options.forEach((option) => {
                if (!optionsMap.has(option.key)) {
                    optionsMap.set(option.key, { "label": option.value, "value": option.key, "category": option.category ? option.category : this.$translate.instant("nui.ngrs.request.no.campus") });
                }
            })
        }
        return Array.from(optionsMap.values());
    }

    private compare(a, b) {
        if (a.category && !b.category) return -1;
        if (!a.category && b.category) return 1;

        if (a.category && b.category) {
            if (a.category.toUpperCase() > b.category.toUpperCase()) return 1;
            if (b.category.toUpperCase() > a.category.toUpperCase()) return -1;
        }

        if (a.value.toUpperCase() > b.value.toUpperCase()) return 1;
        if (b.value.toUpperCase() > a.value.toUpperCase()) return -1;

        return 0;
    }

    public get locationField() {
        return this._locationField;
    }

    public get locationFieldForEBookRequest() {
        return this._locationFieldForEBookRequest;
    }

    public get dateField() {
        return this._dateField;
    }
    public set dateField(value) {
        this._dateField = value;
    }

    public get emailField() {
        return this._emailField;
    }

    public get alternativeEmailField() {
        return this._alternativeEmailField;
    }

    public get articleTitleField() {
        return this._articleTitleField;
    }

    public get articleAuthorField() {
        return this._articleAuthorField;
    }

    public get issueField() {
        return this._issueField;
    }

    public get publicationDateField() {
        return this._publicationDateField;
    }

    public get chapterTitleField() {
        return this._chapterTitleField;
    }

    public get chapterAuthorField() {
        return this._chapterAuthorField;
    }

    public get chapterNumberField() {
        return this._chapterNumberField;
    }

    public get fromPageField() {
        return this._fromPageField;
    }

    public get toPageField() {
        return this._toPageField;
    }

    public get composerField() {
        return this._composerField;
    }
    
    public get opusField() {
        return this._opusField;
    }

    public get songMovementField() {
        return this._songMovementField;
    }
      
    public get partField() {
        return this._partField;
    }

    public get levelOfServiceField() {
        return this._levelOfServiceField;
    }

    public get additionalInformationField() {
        return this._additionalInformationField;
    }

    public isAdditionalInformationFieldVisible(): boolean {
        return this._showAdditionalInformationField;
    }

    public get formData() {
        // if (this.canRefinePUAOffer()){
        //     this._refineOfferDisabled = false;
        // }
        return this._formData;
    }

    private isRefineEnabledForSpecificEditionOnly() {
        if(this.specificEditionFieldVisible()) {
            return (this.showSpecificEditionRefineWarning() || this.showVolumeRefineWarning());
        }
        return false;
    }

    private shouldRefineAfterChoosingPUAMember() {
        return this.isOtherMemberPickupMode();
    }

    private canRefinePUAOffer() {
        return this.shouldRefineAfterChoosingPUAMember() || this._canRestore;
    }
    
    public set formData(value) {
        this._formData = value;
    }

    public clearForm() {
        this._formData = {};
        this._copyRightsCheckBoxField.options[0].value = false;
        this._specificEditionCheckBoxField.options[0].value = false;
        this.setSpecificEditionOnlyFields();
        this._showResourceTypeRefineWarning = false;
        this._selectedResourceType = '';
    }

    public refineOffer() {
        this._refineOfferInProgress = true;
        this._showResourceTypeRefineWarning = false;
        this.refineFieldsSnapshot = {
            myPublicationDate: this._formData.myPublicationDate,
            myVolume: this._formData.myVolume,
            mySpecificEditionOnly: this._formData.mySpecificEditionOnly,
            mySpecificEditionPublicationDate: this._formData.mySpecificEditionPublicationDate,
            myEdition: this._formData.myEdition,
            puaPickupMember: this._isPuaOffer ? this._formData.myPickupMember : -1,
            myResourceType: (this._formData.myResourceType != null ? this._formData.myResourceType : '') + ''
        };
        let result = this.ngrsService.getTitleRecordIdFromItem(this.item);
        let mmsIdArr = result[0];
        let globalIndexArr = result[1];
        if(mmsIdArr){
            this._mmsId = mmsIdArr[0];
        }

        const selectedResourceType = this._selectedResourceType || undefined;

        if (this.isArticleFromJournal()) {
            this.physicalBestOfferService.getDigitalBestOffer(this._mmsId, this.item, this._formData).then(response => {
                this.setBestOffer(response, true);
            });
            this._refineOfferDisabled = true;
            return;
        }

        if(this.isEbookOffer()){
            if(globalIndexArr && (globalIndexArr[0].indexOf('cdi_globaltitleindex_catalog_') === 0
                || globalIndexArr[0].indexOf('globaltitleindex_catalog_') === 0)){
                this.physicalBestOfferService.getBestEbookOfferByGlobalIndex(this._mmsId, this.item, this.pickupAnywhereService.getSelectedPickupInformation(), this._formData)
                    .then(response => this.setBestEbookOffer(response));
            } else {
                this.physicalBestOfferService.getBestEbookOffer(this._mmsId, this.item, this.pickupAnywhereService.getSelectedPickupInformation(), this._formData)
                    .then(response => this.setBestEbookOffer(response));
            }
        }else if (globalIndexArr && (globalIndexArr[0].indexOf('cdi_globaltitleindex_catalog_') === 0
            || globalIndexArr[0].indexOf('globaltitleindex_catalog_') === 0)) {
            this.physicalBestOfferService.getbestOfferByGlobalIndex(this._mmsId,this.item, this.pickupAnywhereService.getSelectedPickupInformation(), this._formData, false, selectedResourceType)
                .then(response => this.setBestOffer(response));
        } else {
            this.physicalBestOfferService.getbestOffer(this._mmsId,this.item, this.pickupAnywhereService.getSelectedPickupInformation(), this._formData, false, selectedResourceType)
                .then(response => this.setBestOffer(response));
        }
        this._refineOfferDisabled = true;
    }

    private setBestOffer(response: mmsIdOfferOutputMap[] | unknown, isDigital?: boolean) {
        if (this._refineOfferInProgress){
            this._refined = true;
        }
        this._refineOfferInProgress = false;
        this._canRestore = false;
        let hash = this.jwtUtilService.getDecodedToken().userGroup + '_' + this._mmsId;
        let responseOffer = isDigital ? this.getDigitalOffer(response) : response[hash].bestPhysicalPolicy;
        if(!responseOffer){
            this._bestOffer = responseOffer;
            responseOffer = this.getNoOfferOfferDetails();
        }
        if(responseOffer && (responseOffer.supplyTime || responseOffer.loanPeriod)){
            responseOffer._noOfferAfterRefine = false;
            if (isDigital) {
                this._showArticleFromJournalRequestFormMessage = false;
            }
        }else{
            if (isDigital) {
                this._showArticleFromJournalRequestFormMessage = this.isDigitalServiceWithNoKnownTerms();
            }
            responseOffer._noOfferAfterRefine = true;
            responseOffer._showPUANoOfferMessage = this.isOtherMemberPickupMode();
        }
        this._bestOffer = responseOffer;
        this._showSpecificEditionRefineWarning = false;
        this._showVolumeRefineWarning = false;
        this._showPublicationDateRefineWarning = false;
        this._showPickupMemberRefineWarning = false;
        this._showResourceTypeRefineWarning = false;

    }

    private setBestEbookOffer(response: mmsIdOfferOutputMap[]) {
        if (this._refineOfferInProgress){
            this._refined = true;
        }
        this._refineOfferInProgress = false;
        this._canRestore = false;
        let hash = this.jwtUtilService.getDecodedToken().userGroup + '_' + this._mmsId;
        let ebookOffer = response && response[hash] ? response[hash].bestEbookPolicy : undefined;
        if(!ebookOffer){
            ebookOffer = {};
            ebookOffer._noOfferAfterRefine = true;
            ebookOffer.ebookOffer = true;
        }
        this._bestOffer = ebookOffer;
        this._showSpecificEditionRefineWarning = false;
        this._showVolumeRefineWarning = false;
        this._showPublicationDateRefineWarning = false;
    }

    public cancelForm(event) {
        this.opendigitalform.openDigitalForm = false;
        this.openphysicalform.openPhysicalForm = false;
        this.openblankform.openBlankForm = false;
        this.clearForm();
        event.preventDefault();
        event.stopPropagation();

    }

    public submitForm(event) {
        if (this.isFormValid() && this.isCopyRightsApproved()) {
            let currentOfferDetails = this.isdigitaloffer? this.digitalbestoffer:this._bestOffer;
            if(this.noOfferFound(currentOfferDetails)){
                currentOfferDetails = this.getNoOfferOfferDetails();
            }
            const runRefineAtServer = this.needToRunRefineAtServer();
            const selectedResourceType = this.isMultiTypeResource() ? this._selectedResourceType : undefined;
            this.physicalBestOfferService.createBorrowingRequest(this._formData, this.item, currentOfferDetails,
                this._alternativeEmailCode, this.isShowCopyRightsStatement(),
                this.pickupAnywhereService.getSelectedPickupInformation(), runRefineAtServer, this.offerInitiallyeBook, selectedResourceType)
                .then((response) => this.setBorrowingRequestResult(response));
            event.preventDefault();
            event.stopPropagation();
            this._requestSubmitted = true;
        }
    }

    private needToRunRefineAtServer() {
        let currentOfferDetails = this.isdigitaloffer? this.digitalbestoffer:this._bestOffer;
        if (this._refined || !this.refineOfferIsVisible() || this.isRefineButtonMandatory()) {
            return false;
        }

        return this.refineFieldChanged();

    }


    private noOfferFound(currentOfferDetails) {
        if (!currentOfferDetails) {
            return true;
        }
        // No terms at all - last resort
        return currentOfferDetails.supplyTime === undefined && currentOfferDetails.loanPeriod === undefined;

    }

    private getNoOfferOfferDetails() {
        let offer = {};
        offer.offerType = 'NONE';
        if (this.isJournal()) {
            offer.policyType = (this.isPhysicalJournal() && !this.isDigitalOffer()) ? "PHYSICAL" : "DIGITAL";
            offer.allowOtherFormat = false;
        } else if (this.isPartOf()) {
            offer.policyType = "DIGITAL";
            offer.allowOtherFormat = false;
        } else if (!this.isdigitaloffer) {
            offer.policyType = "PHYSICAL";
            offer.allowOtherFormat = this._allowOtherFormats.checked;
        } else {
            offer.policyType = "DIGITAL";
            offer.allowOtherFormat = false;
        }
        if (this._bestOffer && this._bestOffer.rotaId) {
            offer.rotaId = this._bestOffer.rotaId;
            offer.loanPeriod = this._bestOffer.loanPeriod;
            offer.supplyTime = this._bestOffer.supplyTime;
        }
        return offer;
    }

    setBorrowingRequestResult(response: any) {
        this.showmessagebar.message = response["reply-text"];
        if (response.status === "ok") {
            this._borrowingRequestOK = true;
            this.showmessagebar.borrowingRequestOK = true;
        } else {
            this._borrowingRequestOK = false;
            this.showmessagebar.borrowingRequestOK = false;
        }
        this.showmessagebar.showMessageBar = true;
    }

    public isSignedIn() {
        return !this.userSessionManagerService.isGuest();
    }

    public getSignInLink() {
        return this.ngrsService.signInLinkRequest;
    }

    public isDigitalOffer() {
        return this.isdigitaloffer;
    }
    public hasDigitalBestOffer() {
        return this.digitalbestoffer !== undefined;
    }

    public digitalFormValidationCheck() {
        if(this._formData.myEmail === this._alternativeEmailCode && !this._formData.myAlternativeEmail) {
            this._isDigitalFormValid = false;
        }
        else if (!this._isLargeForm) {
            this._isDigitalFormValid = true;
        }
        else {
            this.checkChapterEnabledFieldsValidation();
            this._isDigitalFormValid = this.isChapterFormValid;
        }
    }

    public isDigitalFormValidation() {
        return this._isDigitalFormValid;
    }

    public isJournalFormValidation() {
        return this._isPhysicalJournalFormValid;
    }

    public isEBookFormValidation() {
        return this._isEBookFormValid;
    }

    public journalFormValidationCheck() {
        if(!this.isDigitalOffer() && isShowPhysicalJournalOffer()){
            if (this.isCodeEnabledforForm('VOLUME') || this.isCodeEnabledforForm('PUBLICATION_DATE')) {
                if (!this._formData.myPublicationDate && !this._formData.myVolume) {
                    this._isPhysicalJournalFormValid = false;
                    return false;
                }
            }
        } else {
            if (this._formData.myEmail === this._alternativeEmailCode && !this._formData.myAlternativeEmail) {
                return false;
            }

            if (this.isCodeEnabledforForm('ARTICLE_TITLE')) {
                if (this._formData.myArticleTitle) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        
        return true; 
    }

    public musicFormValidationCheck() {
        this._isDigitalFormValid = false;
        if (this.isCodeEnabledforForm('FROM_PAGE_TO_PAGE') || this.isCodeEnabledforForm('OPUS') || this.isCodeEnabledforForm('SONG_MOVEMENT') || this.isCodeEnabledforForm('PART')){
            if(!this._formData.myOpus && 
                !this._formData.mySongMovement && 
                !this._formData.myPart && 
                !(this._formData.myFromPage && this._formData.myToPage)){
                this._isDigitalFormValid = false;
            } else{
                this._isDigitalFormValid = true;
            }
        }
        return this._isDigitalFormValid;
    }

    public validateMandatoryFields() {
        let currentElements = [];
        let formFieldElements = document.getElementsByClassName("form_field");
        if (formFieldElements) {
            for (let i = 0; i < formFieldElements.length; i++) {
                if (formFieldElements[i].id) {
                    currentElements.push(formFieldElements[i].id);
                }
            }
        }

        let pageFieldElements = document.getElementsByClassName("form_field_2");
        if (pageFieldElements) {
            for (let i = 0; i < pageFieldElements.length; i++) {
                if (pageFieldElements[i].id) {
                        currentElements.push( pageFieldElements[i].id)
                }
            }
        }

        for (let i = 0; i < currentElements.length; i++) {
            switch (currentElements[i]) {
                case 'ARTICLE_AUTHOR':
                    if (this._articleAuthorField.mandatory && !this._formData.myArticleAuthor) {
                        return false;
                    }
                    break;
                case 'ARTICLE_TITLE':
                    if (this._articleTitleField.mandatory && !this._formData.myArticleTitle) {
                        return false;

                    }
                    break;
                case 'CHAPTER_AUTHOR':
                    if (this._chapterAuthorField.mandatory && !this._formData.myChapterAuthor) {
                        return false;

                    }
                    break;
                case 'CHAPTER_NUMBER':
                    if (this._chapterNumberField.mandatory && !this._formData.myChapterNumber) {
                        return false;

                    }
                    break;
                case 'CHAPTER_TITLE': if(this._chapterTitleField.mandatory && !this._formData.myChapterTitle){
                    return false;
                }
                    break;
                case 'COMPOSER':
                    if (this._composerField.mandatory && !this._formData.myComposer) {
                        return false;

                    }
                    break;
                case 'EMAIL':
                    if (this._emailField.mandatory && !this._formData.myEmail) {
                        return false;

                    }
                    break;
                case 'ISSUE':
                    if (this.issueField.mandatory && !this._formData.myIssue) {
                        return false;

                    }
                    break;
                case 'LEVEL_OF_SERVICE_DIGITAL':
                    if (this._levelOfServiceField.mandatory && !this._formData.myLevelOfService) {
                        return false;

                    }
                    break;
                case 'LEVEL_OF_SERVICE_PHYSICAL':
                    if (this._levelOfServiceField.mandatory && !this._formData.myLevelOfService) {
                        return false;

                    }
                    break;
                case 'NOT_NEEDED_AFTER':
                    if (this._dateField.mandatory && !this._formData.myDate) {
                        return false;

                    }
                    break;
                case 'NOTE':
                    if (this._noteField.mandatory && !this._formData.myNote) {
                        return false;

                    }
                    break;
                case 'OPUS':
                    if (this._opusField.mandatory && !this._formData.myOpus) {
                        return false;

                    }
                    break;
                case 'PART':
                    if (this._partField.mandatory && !this._formData.myPart) {
                        return false;
                    }
                    break;
                case 'PICKUP_INSTITUTION':
                    if (this._pickupInstitutionFNField.mandatory && !this._formData.myPickupInstitution) {
                        return false;
                    }
                    break;
                case 'PICKUP_LOCATION':
                    if (this._locationField.mandatory && !this._formData.myLocation) {
                        return false;
                    }
                    break;
                case 'PICKUP_LOCATION_FOR_EBOOK':
                    if (this._locationFieldForEBookRequest.mandatory && !this._formData.myLocationForEBook) {
                        return false;
                    }
                    break;
                case 'PUBLICATION_DATE':
                    if (this._publicationDateField.mandatory && !this._formData.myPublicationDate) {
                        return false;
                    }
                    break;
                case 'SONG_MOVEMENT':
                    if (this._songMovementField.mandatory && !this._formData.mySongMovement) {
                        return false;
                    }
                    break;
                case 'VOLUME':
                    if (this._volumeField.mandatory && !this._formData.myVolume) {
                        return false;
                    }
                    break;
                case 'FROM_PAGE': if(this._fromPageField.mandatory && !this._formData.myFromPage) {
                    return false;
                }
                    break;
                case 'TO_PAGE': if(this._toPageField.mandatory && !this._formData.myToPage) {
                    return false;
                }
                    break;
                case 'ALTERNATIVE_EMAIL': if (this._alternativeEmailField.mandatory && !this._formData.myAlternativeEmail){
                    return false;
                }
                    break;
                case 'EDITION': if(this._editionField.mandatory && !this._formData.myEdition) {
                    return false;
                }
                    break;
                case 'PUBLICATION_DATE_FOR_SPECIFIC_EDITION': if(!this._formData.mySpecificEditionPublicationDate) {
                    return false;
                }
                    break;
                case 'ADDITIONAL_INFORMATION':
                    if (this._additionalInformationField.mandatory && !this._formData.myAdditionalInformation) {
                        return false;
                    }
                    break;
                case 'RESOURCE_TYPE':
                    // For resource type, empty string represents "Any Resource Type" and is valid
                    if (this._resourceTypeField.mandatory && this._formData.myResourceType === undefined) {
                        return false;
                    }
                    break;
                default:
                    break;
            }
        }

        return true;
    }

    public isFormValid(){
        if (!this.validateMandatoryFields()){
            return false;
        }

        //journal request
        if (this.isJournal()) {
            return this.journalFormValidationCheck();
        }

        if(this.isMusic() && this.isdigitaloffer){
             return this.musicFormValidationCheck();
        }

        // physical last resort request
        if (!this.isFNRotaOffer() && this.isblankform && !this.isdigitaloffer && this._formData.myLocation) {
            if (!this._allowOtherFormats.checked) {
                return true;
            } else if (this._formData.myEmail) {
                return true;
            }
        }

        if (this.isFNRotaOffer() && this.isblankform && !this.isdigitaloffer && this.pickupInstitutionAndLocationValid()) {
            if (!this._allowOtherFormats.checked) {
                return true;
            } else if (this._formData.myEmail) {
                return true;
            }
        }
        // digital last resort request
        else if (this.isblankform && this.isdigitaloffer && this._formData.myEmail) {
            this.digitalFormValidationCheck();
            if (this._isDigitalFormValid) {
                if (!this._allowOtherFormats.checked || this._formData.myLocation) {
                    return true;
                }
            }
        }
        // digital request
        else if (!this.isblankform && this.isdigitaloffer && this._formData.myEmail) {
            this.digitalFormValidationCheck();
            if (this._isDigitalFormValid) {
                return true;
            } else {
                return false;
            }
        }
        // physical request
        else if (this.isFNRotaOffer() && !this.isblankform && !this.isdigitaloffer && (this._pickupAnywhereEnabled || this.pickupInstitutionAndLocationValid())){
            return true;
        }

        else if (this.isNonRotaPhysicalRequestValid()) {
            return true;
        }

        //we will enter here if we have no pickup location for the eBook request
        if(this.isEbookOffer() && !(this._locationFieldForEBookRequest.options.length || this._pickupAnywhereEnabled)){
            this._isEBookFormValid = false;
        } else if (this.isEbookOffer() && (this._locationFieldForEBookRequest.options.length || this._pickupAnywhereEnabled)){
            if(!this._formData.myLocationForEBook){
                this._formData.myLocationForEBook = this._locationFieldForEBookRequest.options[0].value;
            }
            return true;
        }

        return false;
    }

    private isNonRotaPhysicalRequestValid(): boolean {
        const isPhysicalRequest = !this.isFNRotaOffer() && !this.isblankform && !this.isdigitaloffer;
        if (!isPhysicalRequest) {
            return false;
        }
        const hasLocalPickupLocation = !!this._formData.myLocation;
        const isPickupAnywhere = !!this._pickupAnywhereEnabled;
        // PUA with another member as pickup: the local pickup location is hidden and not required
        const isPUAPickupAtOtherMember = this.isOtherMemberPickupMode();
        return hasLocalPickupLocation || isPickupAnywhere || isPUAPickupAtOtherMember;
    }

    private pickupInstitutionAndLocationValid(){
        if (this.isCodeEnabledforForm('PICKUP_LOCATION') &&  this.isCodeEnabledforForm('PICKUP_INSTITUTION')){
            return this._formData.myPickupInstitution && this._formData.myPickupLibrary;
        } else if (this.isCodeEnabledforForm('PICKUP_LOCATION')){
            return this._formData.myLocation;
        } else{
            return true;
        }
    }

    public isCopyRightsApproved() {
        return (this.isShowCopyRightsStatement() && this._copyRightsCheckBoxField.options[0].value == true) || !this.isShowCopyRightsStatement();
    }

    public getOfferLoanPeriod() {
        return this._bestOffer.loanPeriod;
    }

    public getOfferSupplyTime() {
        if(this._bestOffer){
            return this._bestOffer.supplyTime;
        }
        return undefined;
    }
    public getDigitalOfferSupplyTime() {
        if(this.digitalbestoffer)
            return this.digitalbestoffer.supplyTime;
        return undefined;
    }

    public showAlternativeEmail() {
        if (this._formData.myEmail && this._formData.myEmail === this._alternativeEmailCode) {
           this.focusOnByName(this.alternativeEmailField.name);
            return true;
        }
        this.focusedAlternativeEmail = false;
        return false;
    }

    public focusOnByName(elmName) {
        let elm = document.getElementsByName(elmName)[0];
        if (elm && !this.focusedAlternativeEmail ) {
            this.focusedAlternativeEmail = true;
            this.$timeout(() => {
                this.smoothScrollUtil.focusOn(elm);
            }, 400);
        }
    }
    
    // old method. discarard after December 22
	    // public getRequestHtml() {
    //     let rsrctype = this.getResourceType();
    //     let filePath = 'components/search/fullView/ngrs/getItRequest/';
    //         console.log("this")
    //         console.log(this)
        
    //     if(rsrctype == 'journal' || rsrctype == 'ejournal'){
    //         filePath += 'jornalGetItRequest.html';
    //     }else if(rsrctype == 'score'){
    //         filePath += 'musicGetItRequest.html';
    //     }else if(rsrctype == 'proceeding'){
    //         filePath +=  this.getProceedingHtml();
    //     }else if (this.isblankform ) {
    //         console.error("this is a blank form and should be fixed")
    //         console.error(this)
    //         filePath += lastResortHtml;
    //     }else if(rsrctype == 'book'){
    //         filePath += largeHtml;
    //     }else{
    //         let rsType = getGenreType(this.item)
    //         if(!rsType || rsType == 'unknown'){
    //             let issn = get(this.item, 'pnx.addata.issn[0]');
    //             if(issn){
    //                return filePath + smallHtml;
    //             }
    //         }
    //         filePath += largeHtml;
    //     }
    //     console.log(filePath)
    //     return filePath ;
    // }
    public getRequestHtml() {
        let rsrctype = getResourceType(this.item);
        let filePath = 'components/search/fullView/ngrs/getItRequest/';
        switch (rsrctype) {
            case 'journal':
                if(isShowPhysicalJournalOffer() && !this.isdigitaloffer){
                    this._isLargeForm = true;
                    filePath += largeHtml;
                    break;
                } else{
                    filePath += 'jornalGetItRequest.html';
                    break;
                }
            case 'ejournal':
                filePath += 'jornalGetItRequest.html';
                break;
            case 'proceeding':
                filePath +=  this.getProceedingHtml();
                break;
            case 'book':
            case 'dissertation':
                this._isLargeForm = true;
                filePath += largeHtml;
                break;
            case 'score':
                filePath += 'musicGetItRequest.html';
                break;
            default:
                let rsType = getGenreType(this.item);
                if(rsType && rsType !== 'unknown'){
                    filePath += smallHtml;
                    break;
                }
                let issn = get(this.item, 'pnx.addata.issn[0]');
                if(issn){
                    filePath += smallHtml;
                    break;
                }
                this._isLargeForm = true;
                filePath += largeHtml;
                break;
            }
            return filePath;
    }

    public isAllowOtherFormatsChecked() {
        return this._allowOtherFormats.checked;
    }

    public getProceedingHtml() {
       if(this.isProceedingWithPageMD()){
           return smallHtml;
       }
       this._isLargeForm = true;
        return largeHtml;
    }

    public isPartOf() {
        let resourceType = getResourceType(this.item);
        if (resourceType == 'bookitem' || resourceType == 'article' ) {
            return true;
        }
        return false;
    }

    public isJournal() {
        let resourceType = getResourceType(this.item);
        if (resourceType == 'journal' || resourceType == 'ejournal') {
            return true;
        }
        return false;
    }

    public isBook() {
        let resourceType = getResourceType(this.item);
        if (resourceType == 'book') {
            return true;
        }
        return false;
    }

    public isMusic() {
        let resourceType = getResourceType(this.item);
        if (resourceType == 'score') {
            return true;
        }
        return false;
    }    
    
    public isProceedingWithPageMD() {
        if(this.item &&  this.item.pnx && this.item.pnx.addata){
            let data = this.item.pnx.addata;
            return data.pages !== undefined || (data.spage !== undefined && data.epage !== undefined);
        }
        return false;
    }

    private closeKeydownSupport(e) {
        if (e.keyCode === 9) {
            e.preventDefault();
            let element = document.querySelector('#offer_request_main_tile') as HTMLElement;
            if (element) {
                element.focus();
            } else {
                element = document.querySelector('#no_offer_request_main_tile') as HTMLElement;
                if (element) {
                    element.focus();
                }
            }
        }
    }

    private saveKeydownSupport(e) {
        if (e.keyCode === 9) {
            e.preventDefault();
            let element = document.querySelector('#form-close-btn') as HTMLElement;
            if (element) {
                element.focus();
            }
        }
    }

    public get copyRightsCheckBoxField() {
        return this._copyRightsCheckBoxField;
    }

    public get specificEditionCheckBoxField() {
        return this._specificEditionCheckBoxField;
    }

    public specificEditionFieldVisible() {
        return this.isSpecificEditionFeatureFlagEnabled() && this.isCodeEnabledforForm('SPECIFIC_EDITION_ONLY') && !this.isPhysicalJournal();
    }

    public isSpecificEditionFeatureFlagEnabled() {
        return this.configurationUtil.getFeatureFlag('rapido_request_specific_edition');
    }

    public get specificEditionPublicationDateField() {
        return this._specificEditionPublicationDateField;
    }

    public get editionField() {
        return this._editionField;
    }

    public isShowCopyRightsStatement() {
        if (this.isblankform && !this.isShowCopyRightsOnBlankForm()) {
            return false;
        }
        return this._showCopyRightsStatement;
    }
    public isShowCopyRightsOnBlankForm() {
        return ((this.isdigitaloffer || this.isPartOf()) || (this.isAllowOtherFormatsChecked() && !this.isdigitaloffer));
    }

    public updateCopyRightsValue() {
        this._copyRightsCheckBoxField.options[0].value = !this._copyRightsCheckBoxField.options[0].value;
    }

    public updateSpecificEditionValue() {
        this._specificEditionCheckBoxField.options[0].value = !this._specificEditionCheckBoxField.options[0].value;
        this.setSpecificEditionOnlyFields();
    }

    public isSpecificEditionOnly(){
        return this._specificEditionCheckBoxField.options[0].value;
    }

    getResourceTypeLabel() {
        let resourceType = get(this.item, 'pnx.display.type[0]','b').toLowerCase();
        switch (resourceType) {
            case 'article': return this.$translate.instant('nui.ngrs.form.description.article');
            case 'audio': return this.$translate.instant('nui.ngrs.form.description.audio');
            case 'book': return this.$translate.instant('nui.ngrs.form.description.book');
            case 'bookchapter': return this.$translate.instant('nui.ngrs.form.description.bookChapter');
            case 'collection': return this.$translate.instant('nui.ngrs.form.description.collection');
            case 'conference_proceeding': return this.$translate.instant('nui.ngrs.form.description.conference_proceeding');
            case 'database': return this.$translate.instant('nui.ngrs.form.description.database');
            case 'dissertation': return this.$translate.instant('nui.ngrs.form.description.dissertation');
            case 'governmentdocument': return this.$translate.instant('nui.ngrs.form.description.GovernmentDocument');
            case 'image': return this.$translate.instant('nui.ngrs.form.description.image');
            case 'journal': return this.$translate.instant('nui.ngrs.form.description.journal');
            case 'kit': return this.$translate.instant('nui.ngrs.form.description.kit');
            case 'legaldocument': return this.$translate.instant('nui.ngrs.form.description.LegalDocument');
            case 'manuscript': return this.$translate.instant('nui.ngrs.form.description.manuscript');
            case 'map': return this.$translate.instant('nui.ngrs.form.description.map');
            case 'newspaper': return this.$translate.instant('nui.ngrs.form.description.newspaper');
            case 'newspaperarticle': return this.$translate.instant('nui.ngrs.form.description.NewspaperArticle');
            case 'other': return this.$translate.instant('nui.ngrs.form.description.other');
            case 'referenceentry': return this.$translate.instant('nui.ngrs.form.description.ReferenceEntry');
            case 'researchdataset': return this.$translate.instant('nui.ngrs.form.description.ResearchDataset');
            case 'review': return this.$translate.instant('nui.ngrs.form.description.Review');
            case 'score': return this.$translate.instant('nui.ngrs.form.description.score');
            case 'statisticaldataset': return this.$translate.instant('nui.ngrs.form.description.StatisticalDataSet');
            case 'technicalreport': return this.$translate.instant('nui.ngrs.form.description.TechnicalReport');
            case 'text_resource': return this.$translate.instant('nui.ngrs.form.description.text_resource');
            case 'video': return this.$translate.instant('nui.ngrs.form.description.video');
            case 'website': return this.$translate.instant('nui.ngrs.form.description.website');
            case 'print_book': return this.$translate.instant('nui.ngrs.form.description.print_book');
            case 'book_chapter': return this.$translate.instant('nui.ngrs.form.description.book_chapter');
            case 'report': return this.$translate.instant('nui.ngrs.form.description.report');
            case 'journal_article': return this.$translate.instant('nui.ngrs.form.description.journal_article');
            case 'conference-paper': return this.$translate.instant('nui.ngrs.form.description.Conference-Paper');
            default: return resourceType;
        }
    }

    public isShowRequestSpinner() {
        return this._requestSubmitted && !this.showmessagebar.showMessageBar;
    }

    public isDigitalServiceWithNoKnownTerms() {
        return this.isArticleFromJournal() && this.isServiceWithNoKnownTerms('RapidoDigitalTile');
    }

    public isPhysicalServiceWithNoKnownTerms() {
        return !this.isdigitaloffer && !this.offerInitiallyeBook && this.isServiceWithNoKnownTerms('RapidoPhysicalTile');
    }

    public isServiceWithNoKnownTerms(serviceType: string) {
        if (this.rapidoservices) {
            const service = this.rapidoservices.find(service => service.serviceType === serviceType);
            if (service && service.noKnownTerms === 'true') {
                return true;
            }
        }
        return false;
    }

    public isNoOfferWithNoKnownTerms() {

        if (this.isArticleFromJournal()) {
            return this.isDigitalServiceWithNoKnownTerms() && !this.foundOfferAfterRefine();
        } else if (this.offerInitiallyeBook) {
            return !this.foundOfferAfterRefine();
        } else {
            return this.isPhysicalServiceWithNoKnownTerms() && !this.foundOfferAfterRefine();
        }
    }

    public requestSubmitted() {
        return this._requestSubmitted;
    }

    public noOfferAfterRefineWithOtherMember() {
        return this.isOtherMemberPickupMode() && this._bestOffer._noOfferAfterRefine;
    }

    public sendDisabled() {
        if (this._requestSubmitted || this._refineOfferInProgress) {
            return true;
        }

        if (this.refineButtonHidden()) {
            return false;
        }
        if (this.showAnyRefineWarning()) {
            return true;
        }


        const refine = !this._refined && this.refineFieldChanged();
        const refineOfferMandatory = this.isRefineButtonMandatory();
        const currentOfferDetails = this.isdigitaloffer ? this.digitalbestoffer : this._bestOffer;
        const offerExists = !this.noOfferFound(currentOfferDetails);

        if (refineOfferMandatory) {
            // Mandatory refine
            if (this.offerInitiallyExists && offerExists) {
                // An offer exists: changing the refine fields disables the send button.
                return refine;
            }
            if (this.offerInitiallyExists) {
                // An offer appeared initially but none remained after refining: decide per request type / DLR.
                return this.isRefinedOfferGoneDisablingSend(this._refined);
            }
            // No offer exists: the refine fields only affect messages, they do not gate the send button here.
            return this.isNoOfferWithNoKnownTerms();
        }

        // Non-mandatory refine
        if (this.offerInitiallyExists && offerExists) {
            // An offer exists: the send button stays enabled so the patron can submit without refining first.
            return false;
        }
        if (this.offerInitiallyExists) {
            // An offer appeared initially but none remained after refining: decide per request type / DLR.
            return this.isRefinedOfferGoneDisablingSend(this._refined);
        }
        // No offer exists: the refine fields only affect messages, they do not gate the send button here.
        return this.isNoOfferWithNoKnownTerms();
    }

    private refineFieldChanged() {
        const volumeChanged = (this._formData.myVolume || '') !== (this.refineFieldsSnapshot['myVolume'] || '');
        const publicationDateChanged = (this._formData.myPublicationDate || '') !== (this.refineFieldsSnapshot['myPublicationDate'] || '');
        const mySpecificEditionOnlyChanged = (this._formData.mySpecificEditionOnly || false) !== (this.refineFieldsSnapshot['mySpecificEditionOnly'] || false);
        const mySpecificEditionPublicationDateChanged = this.myEditionTicked() && (this._formData.mySpecificEditionPublicationDate || '') !== (this.refineFieldsSnapshot['mySpecificEditionPublicationDate'] || '');
        const myEditionChanged = this.myEditionTicked() && (this._formData.myEdition || '') !== (this.refineFieldsSnapshot['myEdition'] || '');
        const puaMemberChanged = this.isOtherMemberPickupMode() && (this._formData.myPickupMember || '') !== (this.refineFieldsSnapshot['puaPickupMember'] || '');

        const currentResourceType = (this._formData.myResourceType != null ? this._formData.myResourceType : '') + '';
        const snapshotResourceType = (this.refineFieldsSnapshot['myResourceType'] != null ? this.refineFieldsSnapshot['myResourceType'] : '') + '';
        const resourceTypeChanged = this.isMultiTypeResource() && currentResourceType !== snapshotResourceType;

        if (resourceTypeChanged && this._formData.myResourceType !== undefined) {
            this._selectedResourceType = this._formData.myResourceType || '';
        }

        return volumeChanged || publicationDateChanged || mySpecificEditionOnlyChanged || mySpecificEditionPublicationDateChanged || myEditionChanged || puaMemberChanged || resourceTypeChanged;
    }

    private isRefinedOfferGoneDisablingSend(refined: boolean): boolean {
        // eBook requests are only allowed with an offer, so disable the send button when the offer is gone.
        if (this.offerInitiallyeBook) {
            return !this.foundOfferAfterRefine();
        }
        // Physical requests rely on the corresponding "Hide Rapido physical..." DLR and
        // article-from-journal requests rely on their existing DLR check.
        return this.isNoOfferWithNoKnownTerms();
    }

    private isRefineButtonMandatory() {
        if (this.isArticleFromJournal()) {
            return this.isCodeMandatoryForForm('REFINE_OFFER_FOR_ARTICLE_FROM_JOURNAL');
        } else if (this.isEbookOffer()) {
            return this.isCodeMandatoryForForm('REFINE_OFFER_FOR_EBOOK');
        }
        return this.isCodeMandatoryForForm('REFINE_OFFER_FOR_PHYSICAL');
    }

    private showAnyRefineWarning() {
        return this.showSpecificEditionRefineWarning()
            || this.showVolumeRefineWarning()
            || this.showPublicationDateRefineWarning()
            || this.showPuaPickupMemberRefineWarning()
            || this.showResourceTypeRefineWarning();
    }

    public isCodeEnabledforForm (code: string) {
        if(this.formscustomization && this.formscustomization.enabledCodesList){
            return this.formscustomization.enabledCodesList.includes(code);
        }
        return false;
    }

    public isCodeMandatoryForForm(code: string){
        if(this.formscustomization && this.formscustomization.mandatoryFieldsList){
            if(this.formscustomization.mandatoryFieldsList.includes(code)){
                return true;
            }
        }
        return false;
    }

    public checkChapterEnabledFieldsValidation(){
        if (this.isCodeEnabledforForm('FROM_PAGE_TO_PAGE') || this.isCodeEnabledforForm('CHAPTER_NUMBER') || this.isCodeEnabledforForm('CHAPTER_TITLE')){
            if(!this._formData.myChapterNumber && !this._formData.myChapterTitle && !(this._formData.myFromPage && this._formData.myToPage)){
                this.isChapterFormValid = false;
            } else{
                this.isChapterFormValid = true;
            }
        }
    }

    public isFNRotaOffer(){       
        if (this._bestOffer == null || typeof this._bestOffer === 'undefined' || typeof this._bestOffer.isFNRota === 'undefined'){
            return false;
        }
        return this._bestOffer.isFNRota;
    }

    public isFNRotaOfferDropDowns(){
        return this.isFNRotaOffer() && this.isCodeEnabledforForm('PICKUP_INSTITUTION') && this.isCodeEnabledforForm('PICKUP_LOCATION');
    }

    private setPickupInstitutionsLocation() {
        let comboOptions = [];
        if(this._pickupInstitutionAndLocationMap && this._pickupInstitutionAndLocationMap instanceof Array){
            this._pickupInstitutionAndLocationMap.forEach(element => {
                if(element.preferredPickupInstitution.key && element.preferredPickupInstitution.value){
                    comboOptions.push({ "label": element.preferredPickupInstitution.value, "value": element.preferredPickupInstitution.key});
                }
            });
        }
        comboOptions.sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
        this._pickupLibraryFNField.options = [];       
        let defaultInstitutionValue = this.getDefaultInstitutionValue(comboOptions);
        if (defaultInstitutionValue) {
            this._pickupInstitutionFNField.mandatory = false;
            this._formData.myPickupInstitution = defaultInstitutionValue;
        }
        this._pickupInstitutionFNField.options = comboOptions;
        this.setPickupLibrariesLocation(true);
    }

    public setPickupLibrariesLocation(isDefault : boolean){
        let loginInstCode= getInstitutionCode();
        if(!this._pickupInstitutionFNField || !this._pickupInstitutionFNField.key){
            return;
        }
        this._formData.myPickupLibrary = null;
        let comboOptions = [];
        let optionsMap = new Map();
        if (loginInstCode == this._formData.myPickupInstitution){
            forEach(this._pickupLocationLocal , (owner) => {
                comboOptions = this.parseOptions(owner.pickupLocation, comboOptions, optionsMap);
                comboOptions = this.parseOptions(owner.preferredLocalPickupLocation, comboOptions, optionsMap);
            });
        } else if(this._pickupInstitutionAndLocationMap && this._pickupInstitutionAndLocationMap instanceof Array){
            this._pickupInstitutionAndLocationMap.forEach(element => {
                if(element.preferredPickupInstitution.key == this._formData.myPickupInstitution){
                    if(element.preferredPickupLocation && element.preferredPickupLocation instanceof Array){
                        element.preferredPickupLocation.forEach(library => {
                            comboOptions.push({ "label": library.value, "value": library.key});
                        });
                    }
                    return;
                }
            });
        }
        comboOptions.sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
        if (isDefault){
            let defaultLibraryValue = this.getDefaultLibraryValue(comboOptions);
            if (defaultLibraryValue) {
                this._pickupLibraryFNField.mandatory = false;
                this._formData.myPickupLibrary = defaultLibraryValue;
            }
        }
        this._pickupLibraryFNField.options = comboOptions;
    }

    private setPickupMember(any){
        if(this.isOtherMemberPickupMode()){
            this.switchLocationSubmenu(false)
            this._refined = false;
        } else {
            this.switchLocationSubmenu(true);
            if (this.bestoffer && this._bestOffer._noOfferAfterRefine){
                this.refineOffer();
            } else {
                this._canRestore = true;
            }
        }
    }

    public showDetailsForArticleFromJournal() {
        if (this.isDigitalServiceWithNoKnownTerms()) {
            return this.foundOfferAfterRefine();
        }
        return true;
    }

    private foundOfferAfterRefine() {
        return this._bestOffer  && this._bestOffer._noOfferAfterRefine === false;
    }

    private switchLocationSubmenu(on: boolean){
        this._locationField.mandatory = on ? this.isPickupLocationFieldMandatory() : false;
        this._locationField.mandatoryIndicator = this._locationField.mandatory;
        this._showSubMenuForPua = on;
    }

    private getDefaultInstitutionValue(comboOptions: any[]) {
        if (comboOptions.length == 1) {
            return comboOptions[0].value
        }
        const defaultValueIndexFilter = (element) => element.value == this._pickupInstitutionDefault;
        let defaultValueIndex = comboOptions.findIndex(defaultValueIndexFilter);
        if (defaultValueIndex > -1) {
            return comboOptions[defaultValueIndex].value;
        }
    }

    private getDefaultLibraryValue(comboOptions: any[]) {
        if (comboOptions.length == 1) {
            return comboOptions[0].value
        }
        const defaultValueIndexFilter = (element) => element.value == this._pickupLibraryDefault;
        let defaultValueIndex = comboOptions.findIndex(defaultValueIndexFilter);
        if (defaultValueIndex > -1) {
            return comboOptions[defaultValueIndex].value;
        }
    }

    public get pickupInstitutionFNField() {
        return this._pickupInstitutionFNField;
    }

    public get pickupLibraryFNField() {
        return this._pickupLibraryFNField;
    }

    public isPhysicalJournal(){
        let resourceType = getResourceType(this.item);
        if(resourceType == 'journal' && isShowPhysicalJournalOffer()){
            return true;
        }
        return false;
    }

    public refineOfferIsVisible(){
        if (this.jwtUtilService.isSelfRegistered() || this.refineButtonHidden()) {
            return false;
        }
        const articleFromJournal = this.isArticleFromJournal();

        if (articleFromJournal) {
            return true;
        } else if (!articleFromJournal && this.isdigitaloffer) {
          return false;
        } else if (this.isPuaOffer()){
            return true;
        } else if((this.isPhysicalJournal() && (this.isCodeEnabledforForm('VOLUME') || this.isCodeEnabledforForm('PUBLICATION_DATE')))){
            return true;
        } else if(!this.isPhysicalJournal() && !this.isEbookOffer() && this.isCodeEnabledforForm('VOLUME')){
            return true;
        } else if(this.specificEditionFieldVisible()){
            return true;
        } else if(this.isMultiTypeResource()){
            return true;
        }
        return false;
    }

    private refineButtonHidden(){
        return (this.isArticleFromJournal() && !this.isCodeEnabledforForm('REFINE_OFFER_FOR_ARTICLE_FROM_JOURNAL'))
            || (this.isEbookOffer() && !this.isCodeEnabledforForm('REFINE_OFFER_FOR_EBOOK'))
            || (!this.isDigitalOffer() && !this.isCodeEnabledforForm('REFINE_OFFER_FOR_PHYSICAL'));

    }

    private isArticleFromJournal() {
        return this.isJournal() && this.isdigitaloffer;
    }

    public getRefineButtonTooltip(){
        if (this.isPuaOffer()){
            return "rapido.tiles.physical.refineOfferPickup.tooltip";
        } else if (this.isJournal() && this.isdigitaloffer) {
            return "rapido.tiles.digital.refineOffer.tooltip";
        }
        return "rapido.tiles.physical.refineOffer.tooltip";
    }

    public getRefineButtonLabel(){
        if (this.isArticleFromJournal()) {
            return "rapido.tiles.digital.refineOffer";
        }
        return "rapido.tiles.physical.refineOffer";
    }


    public onPhysicalJournalFieldChange(fieldName, newValue){
        if (newValue === this.refineFieldsSnapshot[fieldName]) {
            return;
        }
        if(this.isPhysicalJournal() && !this.isDigitalOffer()){
            this._bestOffer = this.getNoOfferOfferDetails();
            this._isPhysicalJournalFormValid = true;
        }
    }

    public onArticleFromJournalFieldChange(fieldName, newValue) {
        if (newValue === this.refineFieldsSnapshot[fieldName]) {
            return;
        }
        if (this.isArticleFromJournal()) {
            if (this.foundOfferAfterRefine()) {
                // TODO - add error message under field
            }

            this._bestOffer = this.getNoOfferOfferDetails();
            this._isDigitalFormValid = true;
        }
    }

    public onRefineFieldChange(newValue, oldValue, fieldName){
        if(!this.refineOfferIsVisible()){
            return;
        }
        let editionFieldChanges = false;
        if (fieldName.toLowerCase().includes('edition')) {
            const mySpecificEditionOnlyChanged = (this._formData.mySpecificEditionOnly || false) !== (this.refineFieldsSnapshot['mySpecificEditionOnly'] || false);
            const mySpecificEditionPublicationDateChanged = this.myEditionTicked() && (this._formData.mySpecificEditionPublicationDate || '') !== (this.refineFieldsSnapshot['mySpecificEditionPublicationDate'] || '');
            const myEditionChanged = this.myEditionTicked() && (this._formData.myEdition || '') !== (this.refineFieldsSnapshot['myEdition'] || '');

            this._refineOfferDisabled = !(mySpecificEditionOnlyChanged || mySpecificEditionPublicationDateChanged || myEditionChanged);
            editionFieldChanges = !this._refineOfferDisabled;
        } else if (fieldName === 'myPickupMember') {
            this._refineOfferDisabled = !this.isOtherMemberPickupMode() || !((newValue || -1) !== (this.refineFieldsSnapshot[fieldName] || -1));
        } else if (fieldName === 'myResourceType') {
            // For single type resources, no refine needed - it's pre-selected and not sent
            if (this.isSingleTypeResource()) {
                this._refineOfferDisabled = true;
                this._showResourceTypeRefineWarning = false;
                return;
            }
            // For multi-type, check if selection changed from snapshot
            // Normalize undefined/null to empty string for consistent comparison
            const currentValue = (newValue != null ? newValue : '') + '';
            const snapshotValue = (this.refineFieldsSnapshot[fieldName] != null ? this.refineFieldsSnapshot[fieldName] : '') + '';
            const resourceTypeChanged = currentValue !== snapshotValue;
            this._refineOfferDisabled = !resourceTypeChanged;
            this._selectedResourceType = (newValue != null ? newValue : '') + '';
        } else {
            this._refineOfferDisabled = !((newValue || '') !== (this.refineFieldsSnapshot[fieldName] || ''));
        }

        this._refined = false;

        if (!this.isRefineButtonMandatory()) {
            return;
        }

        if (!this.offerInitiallyExists) {
            return;
        }
        if(newValue !== oldValue) {
            switch (fieldName) {
                case 'myVolume':
                    this._showVolumeRefineWarning = !this._refineOfferDisabled;
                    break;
                case 'myPublicationDate':
                    this._showPublicationDateRefineWarning = !this._refineOfferDisabled;
                    break;
                case 'mySpecificEditionOnly':
                    this._showSpecificEditionRefineWarning = editionFieldChanges;
                    break;
                case 'mySpecificEditionPublicationDate':
                    this._showSpecificEditionRefineWarning = editionFieldChanges;
                    break;
                case 'myEdition':
                    this._showSpecificEditionRefineWarning = editionFieldChanges;
                    break;
                case 'myPickupMember':
                    this._showPickupMemberRefineWarning = !this._refineOfferDisabled;
                    break;
                case 'myResourceType':
                    this._showResourceTypeRefineWarning = !this._refineOfferDisabled;
                    break;
                default:
                    break;
            }
        }
    }

    private myEditionTicked() {
        return this._formData.mySpecificEditionOnly && (this._formData.mySpecificEditionOnly === true || this._formData.mySpecificEditionOnly.toLowerCase() === 'yes');
    }

    public isEbookOffer(){
        if (this.offerInitiallyeBook) {
            return true;
        }
        if (!this._bestOffer || !this._bestOffer.ebookOffer){
            return false;
        }
        return this._bestOffer.ebookOffer;
    }

    public isOtherMemberPickupMode(){
        if (!this._isPuaOffer){
            return false;
        }
        return this._formData.myPickupMember != -1 && this._formData.myPickupMember != null && this._formData.myPickupMember !== '' && this._formData.myPickupMember !== undefined;
    }

    public isPuaOffer(){
        return this._bestOffer != undefined
            && this._bestOffer.puaCentralMembers != undefined
            && Object.keys(this._bestOffer.puaCentralMembers).length > 0
            && !this.isEbookOffer();
    }

    public setSpecificEditionOnlyFields(){
        if(this.isSpecificEditionOnly()){
            this._formData.myEdition = get(this.item, 'pnx.addata.edition');
            this._formData.mySpecificEditionPublicationDate = getPublicationDate(this.item);
        }
    }

    private getDigitalOffer(response: unknown) {
        if(response !== null && response.rapidILLTimeOut) {
            this.physicalBestOfferService.setIsTimeOutFromRapid(true);
            return null;
        }
        return response;
    }

    public showSpecificEditionRefineWarning(){
        return this._showSpecificEditionRefineWarning;
    }

    public showPuaPickupMemberRefineWarning(){
        return this._showPickupMemberRefineWarning;
    }

    public showVolumeRefineWarning(){
        return this._showVolumeRefineWarning;
    }

    public showPublicationDateRefineWarning(){
        return this._showPublicationDateRefineWarning;
    }

    public showResourceTypeRefineWarning(){
        return this._showResourceTypeRefineWarning;
    }

    public isSelfRegistered() {
        return this.jwtUtilService.isSelfRegistered();
    }

    // Resource type selection methods for multi-type GTI records
    private initializeResourceTypeFromOffer(offer: any) {
        if (!isRapidoOfferByResourceTypeEnabled()) {
            return;
        }

        // Material type is only relevant for physical offers
        if (this.isdigitaloffer || this.offerInitiallyeBook) {
            return;
        }

        // Read material types from the offer object
        const availableResourceTypes = offer && offer.availableResourceTypes;

        if (availableResourceTypes && availableResourceTypes.length > 1) {
            this._availableResourceTypes = availableResourceTypes;
            this._selectedResourceType = ''; // No pre-selection
            this.setupResourceTypeField();
        } else if (availableResourceTypes && availableResourceTypes.length === 1) {
            // Single resource type: pre-select it automatically (no user action needed)
            this._availableResourceTypes = availableResourceTypes;
            this._selectedResourceType = availableResourceTypes[0];
            this.setupResourceTypeFieldForSingleType();
        } else {
            this._availableResourceTypes = [];
            this._selectedResourceType = '';
        }
    }

    private setupResourceTypeFieldForSingleType() {
        // When there's only one resource type, pre-select it without requiring user interaction
        let options = [];
        options.push({ "label": this._availableResourceTypes[0], "value": this._availableResourceTypes[0] });
        this._resourceTypeField.options = options;
        this._formData.myResourceType = this._availableResourceTypes[0];
    }

    private setupResourceTypeField() {
        let options = [];
        // Add empty option at the beginning - no pre-selection
        options.push({ "label": this.$translate.instant('nui.ngrs.anyResourceType.label'), "value": "" });
        this._availableResourceTypes.forEach((resourceType) => {
            options.push({ "label": resourceType, "value": resourceType });
        });
        this._resourceTypeField.options = options;
        this._formData.myResourceType = ''; // No pre-selection
    }


    public isMultiTypeResource(): boolean {
        return isRapidoOfferByResourceTypeEnabled()
            && this._availableResourceTypes != undefined
            && this._availableResourceTypes.length > 1
            && this.isCodeEnabledforForm('RESOURCE_TYPE')
            && !this.isdigitaloffer
            && !this.isEbookOffer();
    }

    public isSingleTypeResource(): boolean {
        return isRapidoOfferByResourceTypeEnabled()
            && this._availableResourceTypes != undefined
            && this._availableResourceTypes.length === 1
            && this.isCodeEnabledforForm('RESOURCE_TYPE')
            && !this.isdigitaloffer
            && !this.isEbookOffer();
    }

    public hasResourceType(): boolean {
        return this.isMultiTypeResource() || this.isSingleTypeResource();
    }
    public get resourceTypeField() {
        return this._resourceTypeField;
    }

    public get availableResourceTypes(): string[] {
        return this._availableResourceTypes;
    }

    public get selectedResourceType(): string {
        return this._selectedResourceType;
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/getItRequest/getItRequest.directive.ts